//Usado para forçar uma quebra de linha
const noWrapText = {
                    whiteSpace: "normal",
                    wordWrap: "break-word"
                  };

export const globalVariables = {
	noWrapText	: noWrapText
}